// SETTINGS V2 atom — SettingsV2Tooltip. Reusable Radix hover/focus tooltip that
// carries the `settings-v2-root p-${theme} mod-nastavenia` scope classes on its
// PORTALLED content so the CSS-var tokens resolve outside .settings-v2-root (the
// SP3/SP4/SP5 portal trap). Copied verbatim from SP5's NotificationCategoryCardV2
// PushTooltip idiom — reads `theme` from Redux itself so callers don't thread it.
//
// The shared RadixTooltip.Provider is hoisted once at SettingsV2Layout (delay 200);
// NEVER add another. Touch: Radix tooltips open on hover/focus only, so on touch
// there is simply no tooltip and the wrapped element's tap/click is untouched.
import React from "react";
import * as RadixTooltip from "@radix-ui/react-tooltip";

import { useAppSelector } from "../../../../shared/hooks/sharedHooks";

export interface SettingsV2TooltipProps {
  text: string;
  children: React.ReactNode;
  /** Preferred side; defaults to "left" (row actions sit at the right edge). */
  side?: "top" | "right" | "bottom" | "left";
}

const SettingsV2Tooltip: React.FC<SettingsV2TooltipProps> = ({
  text,
  children,
  side = "left",
}) => {
  const theme = useAppSelector((s) => s.settingsV2Ui.theme);

  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          className={`settings-v2-root p-${theme} mod-nastavenia`}
          side={side}
          sideOffset={6}
          collisionPadding={10}
          style={{
            background: "var(--ink)",
            color: "var(--bg)",
            fontSize: 11.5,
            lineHeight: 1.45,
            padding: "7px 10px",
            borderRadius: 7,
            maxWidth: 260,
            boxShadow: "0 8px 24px rgba(15, 23, 30, 0.18)",
            zIndex: 1400,
          }}
        >
          {text}
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
};

export default SettingsV2Tooltip;
